import Api from '../api';

const resource = '/country';

export default {
  get(code: string) {
    return Api.post(`${resource}`, {
      code,
    });
  },
};
